<template>
  <v-dialog :value="value" max-width="500px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ arch ? 'Edit Architecture' : 'Add Architecture' }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col v-for="field in fields" :key="field.key" :cols="field.cols">
              <v-text-field
                :value="form[field.key]"
                @input="form[field.key] = field.type === 'number' ? Number($event) : $event"
                :label="field.label"
                :placeholder="field.placeholder"
                :hint="field.hint"
                :persistent-hint="!!field.hint"
                :type="field.type === 'number' ? 'number' : 'text'"
                outlined dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="$emit('input', false)">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">
          {{ arch ? 'Update' : 'Add' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiService } from '../../service/api.service'

export default {
  name: 'JetsonArchDialog',
  props: {
    value: { type: Boolean, default: false },
    arch: { type: Object, default: null }
  },
  data () {
    return {
      saving: false,
      form: this.emptyForm(),
      fields: [
        { key: 'family', type: 'text', cols: 12, label: 'Family Name', placeholder: 'e.g., llama3.1', hint: 'Used for matching model names' },
        { key: 'n_layers', type: 'number', cols: 4, label: 'Layers' },
        { key: 'n_kv_heads', type: 'number', cols: 4, label: 'KV Heads' },
        { key: 'head_dim', type: 'number', cols: 4, label: 'Head Dim' }
      ]
    }
  },
  watch: {
    value (open) {
      if (open) {
        this.form = this.arch ? { ...this.arch } : this.emptyForm()
      }
    }
  },
  methods: {
    emptyForm () {
      return { family: '', n_layers: 32, n_kv_heads: 8, head_dim: 128 }
    },
    async save () {
      this.saving = true
      try {
        if (this.arch) {
          await apiService.put(`admin/llm_models/jetson-model-arch/${this.arch.id}`, this.form)
          this.$emit('saved', 'Architecture updated')
        } else {
          await apiService.post('admin/llm_models/jetson-model-arch', this.form)
          this.$emit('saved', 'Architecture added')
        }
        this.$emit('input', false)
      } catch (e) {
        this.$emit('error', e.response?.data?.error || 'Save failed')
      }
      this.saving = false
    }
  }
}
</script>
